import { useEffect } from "react";
import Aos from "aos";

import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Servicesss";
import Portfolio from "./components/Portfolio";
import Hero2 from "./components/Hero2";
import Footer from "./components/Footer";
import Reviews from "./components/Reviews";
import Call from "./components/Call";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <Header></Header>
      <Hero></Hero>
      <Hero2></Hero2>
      <Services></Services>
      <Reviews></Reviews>
      <Portfolio></Portfolio>
      <Call></Call>

      <Footer></Footer>
    </>

  )
}

export default App;